import type {
  OrderCancellationPolicyActionType,
  PostPutOrderCancellationPolicyEscalationRequestAdmin
} from '@/backend/market'

export class CreateUpdateOrderCancellationPolicyEntity {
  name?: string | null
  description?: string | null
  isEnabled?: boolean
  countThreshold?: number | null
  windowHours?: number | null
  actionType?: OrderCancellationPolicyActionType
  closeDurationHours?: number | null
  cancellationRatioPercentageThreshold?: number | null
  priority?: number | null
  cancelOrderReasonIds?: number[]
  escalation?: PostPutOrderCancellationPolicyEscalationRequestAdmin
}
